import { Pipe, PipeTransform} from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'timestampFormat'
  })
  export class TimestampFormatPipe extends DatePipe implements PipeTransform {
    
  }